import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'conversations';

const getConversationMessageMediaById = async ({ id }) => {
  const method = 'GET';
  const url = `${USE_CASE_URL}/${id}`;

  const blob = await request({ method, url, responseType: 'blob' });
  return blob;
};

export default getConversationMessageMediaById;
